import React from "react";

export default function FilterIcon({ color = "#FFF", width = 21, height = 21 }) {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 21 21"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M2.625 3.13756V1.75H18.375V3.13756L11.6313 9.88128L11.375 10.1376V10.5V16.9592L9.625 17.8342V10.5V10.1376L9.36872 9.88128L2.625 3.13756Z"
				fill={color}
				stroke={color}
				strokeWidth="1.75"
				strokeMiterlimit="10"
				strokeLinecap="square"
			/>
		</svg>
	);
}
